<!-- 大转盘抽奖 -->
<template>
  <div class='luckyDraw-page'>
    <div class="luckyDraw-container">
      <!-- :style="{'padding-top':screenHeight > 750 ? '70%' : 'auto'}" -->
      <!-- <img class="banner-bg" src="../../assets/images/prize/banner-bg.png" alt=""> -->
      <img class="gk-img" src="../../assets/images/prize/gk-img.png" alt="">
      <img class="rule-img" @click="handleGoRule" src="../../assets/images/prize/rule.png" alt="" >
      <img class="my-prize" @click="handleGoMyPrize" src="../../assets/images/prize/my-prize.png" alt="" >
      <LuckyWheel
        v-if="isShowLuckyWheel"
        class="luckyWheel"
        ref="myLucky"
        width="8.4rem"
        height="8.4rem"
        :prizes="prizes"
        :blocks="blocks"
        :buttons="buttons"
        :defaultConfig="defaultConfig"
        @start="startCallback"
        @end="endCallback"
      />
      <div class="prize-number" v-if="!isEmptyObj(loginInfo)">
        抽奖次数{{prizeNumer}}次
      </div>
      <div class="share-box copyText df-between" :style="{'visibility': !isLoading && isSign == '0' && !myPrizeId && this.prizeNumer == '0' ? 'visible' : 'hidden'}" @click="handleCopy" :data-clipboard-text="copyText">
        <div class="left">
          <div class="title">复制内容分享获得抽奖机会</div>
          <p>朋友圈转发分享：{{ copyText }}</p>
        </div>
        <div class="right df-center" @click="handleGoShare"> 复制去分享 </div>
      </div>
    </div>
    <div class="luckyDraw-footer"> </div>
    <van-popup v-model="isShowRule" round position="bottom">
      <div class="rule-detail">
        <div class="rule-title">幸运抽奖规则</div>
        <div class="time">
          幸运抽奖时间：
          <span>2023年8月16日  10:00-17:00</span>
        </div>
        <div class="rule-info">
          幸运抽奖规则：
          <span style="line-height: 1.5;">抽奖者点击开始转动“幸运大转盘”自动摇奖,当大转盘上奖品项停在“幸运指针”上时,抽奖者可获该奖项。（每个手机ID只能领取一次）</span>
        </div>
        <div class="remark">
          备注：
          <span>最终解释权归感控工作间所有。</span>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="isShowLogin" title="" :showConfirmButton="false" :show-cancel-button="false">
      <div class="dialog-box" style="padding: 0px 15px;">
        <div class="title">
          登录
        </div>
        <van-form>
          <div class="field-box">
            <van-field
              v-model="mobilePhone"
              @input="handleMobilePhone"
              type="tel"
              name=""
              label=""
              placeholder="请输入感控工作间手机号码"
              maxlength="11"
            />
          </div>
          <div class="field-box">
            <van-field
              v-model="verificationCode"
              type="number"
              name=""
              label=""
              placeholder="请输入验证码"
              maxlength="8"
            >
              <template #button>
                <div class="getCode-btn yetCode" v-if="timeCount>0" ><span>重新获取 ({{timeCount}})</span></div>
                <div class="getCode-btn" @click="getCode" v-else >点击获取</div>
              </template>
            </van-field>
          </div>
        </van-form>
        <div class="btn df-center" style="margin-top: 25px;" @click="handleLogin">提交</div>
      </div>
    </van-dialog>
    <van-dialog
      :before-close="beforeColseValidModal"
      show-cancel-button
      v-model="showValidModal"
      class="shareauth-dialog"
      confirmButtonText="确认"
      confirmButtonColor="black"
      cancelButtonText="取消"
      cancelButtonColor="black"
      title="滑动验证"
      :showConfirmButton="false"
    >
      <div id='slideVerifyBox' style="margin-bottom: 20px;">
        <slide-verify ref="slideblock" @success="onSuccess" :w='myWidth' :slider-text="silderText" :imgs="imgs"></slide-verify>
      </div>
      <div class="shareauth-validimagebox" v-if="false">
        <div
          @click="getValidImageData"
          class="shareauth-validimage"
        >
          <van-image
            class="sliderverify-verifyimage"
            ref="verifyImage"
            v-if="vaildImgInfo.imgSrc"
            :src="vaildImgInfo.imgSrc"
          >
            <template v-slot:error>加载失败</template>
          </van-image>
        </div>
        <div class="shareauth-validrefish">
          <span>点击图片刷新</span>
        </div>
      </div>
      <van-field
        v-if="false"
        v-model="verifyAnswer"
        @focus="vaildImgInfo.errorMsg = ''"
        type="tel"
        center
        clearable
        placeholder="输入计算答案"
      >
        <template #button>
          <div
            class="van-ellipsis"
            style="color: #f00"
          >
            {{ vaildImgInfo.errorMsg }}
          </div>
        </template>
      </van-field>
    </van-dialog>
    <van-dialog v-model="isShowWinning" title="" :showConfirmButton="false" :show-cancel-button="false">
      <div class="dialog-box">
        <div class="title">
          恭喜您中奖了
        </div>
        <p>{{ winningData.prizeName }}</p>
        <img class="winning-img" :src="downloadPath + winningData.iconUrl" />
        <div class="btn df-center" @click="handleReceiveAward">领取</div>
      </div>
    </van-dialog>
    <van-dialog v-model="isShowVersionsUpdate" style="top: 50%;" title="" :showConfirmButton="false" :show-cancel-button="false">
      <div class="dialog-box qst-box">
        <div class="title">
          问卷调查
        </div>
        <div class="qst-list">
          <div class="item" v-for="(item,index) in qstData" :key="index">
            <div class="item-title">{{ item.qstName }} <span>{{item.qstRemark}}</span></div>
            <van-checkbox-group v-model="item.checkBoxResult" max="3">
              <div v-for="(d,idx) in item.opts" :key="idx">
                <van-checkbox :name="d.optId" icon-size="18" checked-color="#16C3F5" shape="square">
                  <div class="item-text">
                    {{ d.optName }}
                  </div>
                </van-checkbox>
                <template v-if='d.containRemakeFlag == "1" && item.checkBoxResult&&item.checkBoxResult.indexOf("H")!=-1'>
                  <textarea
                    name=""
                    v-model="item.remark"
                    ref="textareaBox"
                    placeholder="输入您想增加的功能"
                    maxlength="100"
                    @blur="handleTextareaChange(index,idx)"
                  ></textarea>
                </template>
              </div>
            </van-checkbox-group>
          </div>
        </div>
        <!-- <div class="btn prize-btn df-center" @click="handleSubmitQst" :style="{'opacity': yetReadCount>0 ? '0.5' : '1'}">{{yetReadCount>0 ? '(' + yetReadCount + 's)' : ''}}提交</div> -->
        <div class="btn prize-btn df-center" @click="handleSubmitQst">
          <div>提交</div>
          <p v-if="isSign == '0'">去分享获取抽奖机会1次</p>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="isShowSignDialog" style="overflow: inherit;" title="" :showConfirmButton="false" :show-cancel-button="false">
      <div class="dialog-box">
        <div class="title vip-title">
          <img class="vip-icon" src="../../assets/images/prize/vip-icon.png" alt="">
        </div>
        <div class="content">
          <div class="sign-text">尊贵的签约用户：</div>
          <div class="sign-text" style="text-indent: 30px;line-height: 1.5;">感谢您一直以来对我们的支持和信任。为了回馈您的厚爱，恭喜您直接获得1次抽奖机会！</div>
        </div>
        <div class="btn df-center" @click="handleLotteryDraw">点击抽奖</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  import { mapState } from 'vuex'
  import Clipboard from 'clipboard'; 
  import slideVerify from '@/components/slideVerify/index.vue'
  import img0 from '../../assets/img.jpg';
  const TIME_COUNT = 60
  const YET_READ_COUNT = 5
  export default {
    data() {
      return {
        myWidth: 0,
        silderText:'请按住滑块，拖动到最右边',
        imgs: [ img0 ],
        isSubmitQst: 0, // 是否填写过问卷调查
        isSign: '',
        isLoading:false,
        screenHeight:'',
        copyText:'快来试试吧，只有亲身体验才能知道这款APP有多实用！',
        prizeListData:[],// 原始接口返回的商品列表数据
        winningData:{}, // 中奖的对象
        isShowLuckyWheel: false,
        comFrom:'',
        mobilePhone: '',
        verificationCode: '',
        isSend: '',
        showValidModal: false,
        verifyAnswer: '',
        vaildImgInfo: {
          imgSrc: '',
          errorMsg: '',
          token: '',
        },
        loginInfo: {},
        myPrizeId: '', // 已中奖的商品id
        prizeNumer: 0, //抽奖次数
        prizeIndex: 0, //中奖索引
        isShowError: false,
        timeCount: 0,
        yetReadCount: 0,
        timer:null,
        isShowRule:false,
        isShowLogin:false,
        isShowWinning:false,
        isShowVersionsUpdate: false,
        isShowSignDialog: false,
        defaultConfig: {
          // gutter: '3px', // 设置间距
          speed: 20,
          stopRange: 0, // 指征在扇形区域的停止范围，建议0~0.8
        },
        blocks: [
          {
            padding: '0.9rem',
            imgs: [{
              src: require('../../assets/images/prize/luckyDraw-bg.png'),
              width: '100%',
              height: '100%',
              rotate: true
            }]
          }
        ],
        buttons: [
          {
            radius: '100%',
            pointer: true,
            imgs: [{
              src: require('../../assets/images/prize/luckyDraw-btn.png'),
              top: '-50%',
              width: '2.3rem',
              height: '2.3rem'
            }]
          },
        ],
        prizes: [
          {
            imgs: [{
              // src: require('../../assets/images/prize/img11.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          },
          {
            imgs: [{
              // src: require('../../assets/images/prize/img22.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          },
          {
            imgs: [{
              // src: require('../../assets/images/prize/img33.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          },
          {
            imgs: [{
              // src: require('../../assets/images/prize/img44.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          },
          {
            imgs: [{
              // src: require('../../assets/images/prize/img55.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          },
          {
            imgs: [{
              // src: require('../../assets/images/prize/img66.png'),
              src: '',
              width: '2.7rem', // 1rem 等于37.5px
              height: '2.4rem'
            }]
          }
        ],
        qstData: []
      }
    },
    components: {
      slideVerify
    },
    computed: {
      ...mapState({
        downloadPath: state => state.downloadPath
      })
    },
    created() {
      this.screenHeight = window.innerHeight;
      if (sessionStorage.getItem('loginInfo')) {
        this.loginInfo = JSON.parse(sessionStorage.getItem('loginInfo'))
        this.isSign = this.loginInfo.signAndAuthFlag
      }
      if (sessionStorage.getItem('luckyDrawPhone')) {
        this.mobilePhone = sessionStorage.getItem('luckyDrawPhone')
      }
      if (!sessionStorage.getItem('prizeListData')) {
        this.initPrizeListData()
      } else {
        this.prizeListData = JSON.parse(sessionStorage.getItem('prizeListData'))
        this.prizeListData.forEach((item, index) => {
          this.prizes[index].imgs[0].src = this.downloadPath + item.turntableIconUrl
        })
        this.isShowLuckyWheel = true
      }
      setTimeout(() => {
        this.initShare('感控工作间的使用经验分享','可以参考借鉴哦')
      }, 500);
    },
    mounted(){
      console.log(this.comFrom,'this.comFrom');
      // if (this.comFrom == 'brandPublicity') {
        this.getPrizeChance()
        this.initQstList()
      // }
      if (this.comFrom == 'myPrize' && this.utils.isIosOrAndroidOrPc() == 'ios') {
        window.location.reload(); // 解决ios下我的奖品页限制了分享后进入此页面分享按钮也未显示问题
      }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        console.log(from,'from');
        if (from.path === "/brandPublicity") {
          vm.comFrom = 'brandPublicity'
        } else if (from.path === "/myPrize") {
          vm.comFrom = 'myPrize'
        }
      });
    },
    beforeRouteLeave(to, from, next) {
      clearInterval(this.timer)
      next()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      onSuccess(times){
        console.log(times,'验证通过');
        this.silderText = '验证通过'
        this.$axios({
          method: 'post',
          url: '/education-intf/api/common/checkCaptchaCode',
          data: {
            data: {
              token: this.vaildImgInfo.token,
              phone: this.mobilePhone,
              result: this.mobilePhone,
            },
          },
        })
        .then((res) => {
          this.closeValidModal()
          if (res.data.code === 0) {
            setTimeout(() => {
              this.isSend = res.data.data
              this.getCode()
            }, 200)
          } else {
            Toast(res.data.msg)
          }
        })
      },
      // 获取问卷调查问题列表
      initQstList () {
        let params = { };
        this.$http.queryActivityQstList(params).then((res) => {
          if (res.code == 0) {
            this.qstData = res.data
          }
        });
      },
      handleTextareaChange(index,idx) {
      },
      // 复制内容
      handleCopy () {
        var clipboard = new Clipboard('.copyText')
        //clipboard后边括号里面的要跟上面起的class类名对得上，注意设置data-clipboard-text
        clipboard.on('success', e => {
          console.log('复制成功', e)
          Toast('复制成功')
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          Toast('手机权限不支持复制功能')
          // 释放内存
          clipboard.destroy()
        })
      },
      isEmptyObj (data) {
        return Object.keys(data).length == 0
      },
      // 查询用户抽奖机会及中奖信息
      getPrizeChance () {
        if (this.mobilePhone) {
          this.isLoading = true
          let params = {
            data: {
              mobile: this.mobilePhone
            }
          };
          this.$http.queryUserActivityRecordByMobile(params).then((res) => {
            if (res.code == 0) {
              this.isLoading = false
              this.prizeNumer = res.data.lotteryNum
              this.myPrizeId = res.data.prizeId
              this.isSubmitQst = res.data.submitAnswerFlag
            } else {
              Toast(res.msg)
            }
          });
        }
      },
      // 根据活动ID(后台写死)获取奖品列表及转盘图片列表
      initPrizeListData () {
        let params = { };
        this.$http.queryPrizeListByActivityId(params).then((res) => {
          if (res.code == 0) {
            this.prizeListData = res.data
            sessionStorage.setItem('prizeListData', JSON.stringify(res.data))
            res.data.forEach((item, index) => {
              this.prizes[index].imgs[0].src = this.downloadPath + item.turntableIconUrl
            })
            this.isShowLuckyWheel = true
          }
        });
      },
      // 抽奖
      handleLotteryDraw () {
        this.isShowSignDialog = false
        this.defaultConfig.stopRange = parseFloat((Math.random()*0.8).toFixed(1));
        this.$http.lotteryDraw({
          data: {
            mobile: this.mobilePhone
          }
        }).then((res) => {
          if (res.code == 0) {
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play()
            this.getPrizeChance()
            this.prizeListData.forEach((v, i) => {
              if (v.prizeId == res.data) {
                this.prizeIndex = i // 根据中奖商品id获取中奖索引
              }
            })
            this.prizeNumer = 0
            this.winningData = this.prizeListData[this.prizeIndex]
            console.log(this.winningData,'中奖对象');
            setTimeout(() => {
              // 调用stop停止旋转并传递中奖索引
              this.$refs.myLucky.stop(this.prizeIndex)
            }, 1000)
          } else {
            Toast(res.msg)
          }
        });
      },
      handleMobilePhone() {
        this.checkPhone()
        if (this.mobilePhone.length == 11) {
          if (!this.isShowError) {
            // 手机号正确
          } else {
            Toast("请填写正确的手机号!");
          }
        }
      },
      checkPhone() {
        if (!/^(13[0-9]|12[2]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[012356789])\d{8}$/.test(this.mobilePhone)) {
          this.isShowError = true
          return false
        } else {
          this.isShowError = false
        }
      },
      getCode() {
        this.checkPhone()
        if (this.isShowError) {
          Toast("请填写正确的手机号!");
          return
        }
        if (!this.isSend) {
          this.showValidModal = true
          this.getValidImageData()
          this.$nextTick(() => {
            this.myWidth = document.getElementById('slideVerifyBox').offsetWidth
          })
        } else {
          if (!this.timer) {
            // 数字验证码
            this.$axios({
              method: 'post',
              url: 'education-intf/api/common/sendValidCodeWithEncryption?DYMD_TOKEN=' + this.isSend,
              data: {
                data: {
                  mobile: this.$getRsaCode(this.mobilePhone),
                  token: this.isSend,
                  code: this.$md5(this.mobilePhone + '|3ORefhmwUH5bmWo8Og9tza2JgVI6HB^X'),
                  sceneType: 3,
                }
              },
            }).then((res) => {
              Toast(res.data.msg)
            })
            
            this.timeCount = TIME_COUNT
            this.timer = setInterval(() => {
              if (this.timeCount > 0 && this.timeCount <= TIME_COUNT) {
                this.timeCount--
              } else {
                this.clearVaildData()
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
        }
      },
      clearVaildData() {
        this.isSend = ''
      },
      getValidImageData() {
        this.verifyAnswer = ''
        // this.$axios({
        //   method: 'post',
        //   url: '/education-intf/api/common/getCheckCaptchaCode',
        // }).then((res) => {
        //   if (res.data.code === 0) {
        //     this.vaildImgInfo.imgSrc = 'data:image/jpeg;base64,' + res.data.data.imgBase64
        //     this.vaildImgInfo.token = res.data.data.token
        //   } else {
        //     Toast(res.data.msg)
        //   }
        // })
        this.$axios({
          method: 'post',
          url: '/education-intf/api/common/getSliderCaptchaCode',
          headers: {
            // "x-userkey": ''
          },
          data: {
            data: {
              mobile: this.mobilePhone,
            },
          },
        }).then((res) => {
          if (res.data.code === 0) {
            this.vaildImgInfo.token = res.data.data.token
          } else {
            Toast(res.data.msg)
          }
        })
      },
      closeValidModal() {
        this.$refs.slideblock.reset();
        this.silderText = '请按住滑块，拖动到最右边'
        this.verifyAnswer = ''
        this.showValidModal = false
      },
      beforeColseValidModal(action, done) {
        console.log(action)
        if (action === 'confirm') {
          if (this.verifyAnswer === '') {
            this.vaildImgInfo.errorMsg = '验证码不能为空'
            done(false)
            return
          }
          this.$axios({
            method: 'post',
            url: '/education-intf/api/common/checkCaptchaCode',
            data: {
              data: {
                token: this.vaildImgInfo.token,
                phone: this.mobilePhone,
                result: this.verifyAnswer,
              }
            },
          })
            .then((res) => {
              if (res.data.code === 0) {
                this.verifyAnswer = ''
                setTimeout(() => {
                  this.isSend = res.data.data
                  done()
                  this.getCode()
                }, 200)
              } else {
                this.vaildImgInfo.errorMsg = res.data.msg || '验证失败'
                setTimeout(() => {
                  this.getValidImageData()
                  done(false)
                }, 200)
              }
            })
            .catch((err) => {
              this.getValidImageData()
              this.vaildImgInfo.errorMsg = '验证失败'
              done(false)
              console.error(err, 'error')
            })
        } else {
          this.closeValidModal()
          done()
        }
      },
      handleLogin () {
        this.checkPhone()
        if (this.isShowError) {
          Toast("请填写正确的手机号!");
          return
        }
        if (!this.verificationCode) {
          Toast("请输入验证码!");
          return
        }
        this.$axios({
          method: 'post',
          url: 'education-intf/api/account/addUserActivityRecord',
          data: {
            data: {
              userName: this.mobilePhone,
              loginType: '1', // 1：短信登录 0或空为密码登录 3、第三方登录 比如小程序 4、第三方短信登录
              // passWord: this.$getRsaCode(this.password), // rsa加密
              verifycode: this.verificationCode,
            }
          },
        }).then((res) => {
          this.qstData.forEach((v, i) => {
            this.$set(v,'checkBoxResult',[])
            this.$set(v,'remark','')
          })
          Toast(res.data.msg)
          if (res.data.code == 0) { // 登录成功后
            clearInterval(this.timer) // 清除获取验证码的定时器
            this.timer = null
            this.isShowLogin = false
            this.loginInfo = res.data.data
            this.prizeNumer = res.data.data.lotteryNum
            this.myPrizeId = res.data.data.prizeId
            this.isSubmitQst = res.data.data.submitAnswerFlag // 是否已经提交过问卷调查答案 0-否  1-是
            this.isSign = res.data.data.signAndAuthFlag // 是否所在医院签约且用户已审核通过  0-否 1-是
            sessionStorage.setItem('loginInfo',JSON.stringify(this.loginInfo))
            sessionStorage.setItem('luckyDrawPhone',this.mobilePhone)
            if (this.isSubmitQst == 0) { // 没有填写过问卷
              this.isShowVersionsUpdate = true
              this.yetReadCount = YET_READ_COUNT
              this.timer = setInterval(() => {
                if (this.yetReadCount > 0 && this.yetReadCount <= YET_READ_COUNT) {
                  this.yetReadCount--
                } else {
                  clearInterval(this.timer)
                  this.timer = null
                }
              }, 1000)
            }
          }
        })
      },
      // 提交问卷
      handleSubmitQst () {
        // if (this.yetReadCount > 0) {
        //   return
        // }
        let qsts = []
        let flag = false
        this.qstData.forEach((v, i) => {
          if (v.checkBoxResult.length > 0) {
            flag = true
          }
          qsts.push({
            qstId:v.qstId,
            answer:v.checkBoxResult.join(),
            remark:v.remark,
          })
        })
        if (!flag) {
          Toast("请至少勾选一项!");
          return
        }
        let params = { 
          data: {
            mobile: this.mobilePhone,
            qsts: qsts
          }
        };
        this.$http.saveUserActivityAnswer(params).then((res) => {
          if (res.code == 0) {
            if (this.isSign == '1') { // 已签约医院的用户
              this.isShowSignDialog = true
            } else { // 未签约用户直接去分享
              this.handleCopy()
              setTimeout(() => {
                this.$router.push({
                  path: "/brandPublicity",
                  query: {
                    comFrom: 'luckyDraw',
                    mobilePhone: this.mobilePhone,
                  }
                })
              },1000)
            }
            this.isShowVersionsUpdate = false
          }
        });
      },
      handleReceiveAward () {
        this.isShowWinning = false
      },
      handleGoRule () {
        this.isShowRule = true
      },
      handleGoMyPrize () {
        if (this.isEmptyObj(this.loginInfo)) {
          this.isShowLogin = true
          return
        }
        this.$router.push({
          path: "/myPrize",
          query: {
            mobilePhone: this.mobilePhone
          }
        })
      },
      handleGoShare () {
        setTimeout(() => {
          this.$router.push({
            path: "/brandPublicity",
            query: {
              comFrom: 'luckyDraw',
              mobilePhone: this.mobilePhone,
            }
          })
        },1000)
      },
      startCallback () {
        if (this.myPrizeId) { // 有奖品的弹窗
          Toast("您当前抽奖次数为0!");
          return
        }
        if (this.isSubmitQst == '1' && this.isSign == '0') { // 提交过问卷且未抽奖的未签约用户
          if (this.prizeNumer == '0') { // 没获得抽奖机会时
            this.$router.push({
              path: "/brandPublicity",
              query: {
                comFrom: 'luckyDraw',
                mobilePhone: this.mobilePhone,
              }
            })
          } else { // 已获得抽奖机会了
            this.handleLotteryDraw()
          }
          return
        }
        if (this.isSubmitQst == '1' && this.isSign == '1') { // 提交过问卷且未抽奖的已签约用户
          this.handleLotteryDraw()
          return
        }
        this.isShowLogin = true
      },
      // 抽奖结束会触发end回调
      endCallback (prize) {
        console.log(prize)
        this.isShowWinning = true
      },
    },
  }
</script>
<style lang='scss' scoped>
.luckyDraw-page{
  position: relative;
  height: 100vh;
  background-color: #0ec4f5;
  // background-image: url('../../assets/images/prize/banner-bg.png');
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  // background-color: #0ec4f5;
  .luckyDraw-container{
    padding-top: 250px;
    padding-bottom: 10px;
    background-image: url('../../assets/images/prize/banner-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-color: #0ec4f5;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    .banner-bg{
      width: 100%;
      height: 100%;
      position: absolute;
      top:0;
      left: 0;
      pointer-events:none;
    }
    .gk-img{
      position: absolute;
      top: 7px;
      left: 11px;
      width: 115px;
      height: 50px;
    }
    .rule-img{
      position: absolute;
      top: 65px;
      right: 4px;
      width: 60px;
      height: 60px;
    }
    .my-prize{
      position: absolute;
      top: 128px;
      right: 4px;
      width: 60px;
      height: 60px;
    }
    .luckyWheel{
      margin: 0 auto ;
    }
    .prize-number{
      margin: 15px auto 20px;
      font-size: 18px;
      color: #ffffff;
    }
    .share-box{
      width: 92%;
      margin: 0 auto;
      padding: 10px 12px 10px 15px;
      background-color: #fff;
      color: #fff;
      border-radius: 10px;
      .left{
        text-align: left;
        flex: 1;
        .title{
          margin-bottom: 12px;
          font-size: 16px;
          color: #1d1b1b;
          font-weight: 500;
          font-family: PingFang SC Medium, PingFang SC Medium-Medium;
        }
        p{
          font-size: 12px;
          color: #666666;
        }
      }
      .right{
        margin-left: 18px;
        width: 90px;
        height: 36px;
        background: linear-gradient(#fff35a 0%, #ffba0c 100%) #ffffff;
        border-radius: 18px;
        font-size: 15px;
        color: #ab441c;
      }
    }
  }
  .rule-detail{
    padding: 25px 15px 30px;
    .rule-title{
      margin-top: 0px;
      font-size: 20px;
      font-family: PingFang SC Medium, PingFang SC Medium-Medium;
      font-weight: bold;
      text-align: left;
      color: #333333;
    }
    div{
      margin-top: 15px;
      font-size: 15px;
      font-weight: 400;
      text-align: left;
      color: #333333;
    }
    span{
      color: #666;
    }
  }
  .dialog-box{
    .title{
      margin: 24px auto 20px;
      font-size: 20px;
      font-weight: bold;
      color: #343434;
    }
    .vip-title{
      margin-top: 70px;
      .vip-icon{
        position: absolute;
        top: -20px;
        left: 0;
        width: 100%;
      }
    }
    p{
      font-size: 14px;
      text-align: center;
      color: #666666;
    }
    .winning-img{
      width: 90px;
      height: 141px;
      margin: 10px auto;
    }
    .content{
      padding: 20px 15px 15px 20px;
      .sign-text{
        margin-bottom: 15px;
        font-size: 18px;
        font-family: PingFang SC Regular, PingFang SC Regular-Regular;
        font-weight: 400;
        text-align: left;
        color: #552323;
      }
    }
    .btn{
      margin: 0px auto 25px;
      width: 221.5px;
      height: 50px;
      background: linear-gradient(#fff35a 0%, #ffba0c 100%) #ffffff;
      border-radius: 25px;
      font-size: 20px;
      color: #ab441c;
    }
  }
  .qst-box{
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    .qst-list{
      flex: 1;
      overflow: scroll;
      padding: 0px 15px 10px;
      .item{
        margin-bottom: 18px;
        .item-title{
          margin-bottom: 15px;
          font-size: 17px;
          font-family: PingFang SC Medium, PingFang SC Medium-Medium;
          font-weight: bold;
          color: #333333;
          text-align: left;
          span{
            color: #999999;
            font-weight: 500;
          }
        }
        .item-text{
          padding: 10px 0px;
          font-size: 15px;
          color: #333;
          text-align: left;
        }
        textarea {
          min-height: 70px;
          width:100%;
          padding:8px 10px;
          font-size: 15px;
          border: 1px solid #eeeeee;
          border-radius: 4px;
        }
      }
    }
    .prize-btn{
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      p{
        font-size: 14px;
        font-weight: 400;
        color: #ab441c;
      }
    }
  }
  .shareauth-dialog {
    padding: 0 15px;
  }
  .shareauth-validimagebox {
    display: flex;
    margin-top: 10px;
    & > div {
      width: 50%;
    }
  }
  .shareauth-validimage {
    padding: 4px 0 0 0;
  }
  .shareauth-validrefish {
    color: #999;
    text-align: right;
    line-height: 45px;
  }
  .field-box{
    margin-bottom: 12px;
    .van-cell{
      // padding: 0px 0px 0px 16px;
      padding-right: 0px;
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
      border: 1px solid #bbb;
      border-radius: 6px;
    }
    .getCode-btn {
      width: 120px;
      height: 50px;
      line-height: 50px;
      background: #ffba0c;
      font-size: 16px;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      color: #ab441c;
      text-align: center;
      span {
        color: #666666;
        font-size: 16px;
      }
    }
    .yetCode{
      background: #dcdcdc;
    }
  }
  .van-cell{
    font-size: 16px;
  }
}
</style>